import React from "react";
import { MeshStandardMaterial, BoxGeometry, EdgesGeometry } from "three";

const Columns = ({ columns, selectedFloor }) => {
  // Materiales
  const selectedMaterial = new MeshStandardMaterial({ color: "#20dcd9", transparent: true, opacity: 0.7 });
  const hideMaterial = new MeshStandardMaterial({ color: "#e2eeee", transparent: true, opacity: 0.1 });

  return (
    <>
      {columns.map((column) => {
        const { geometry, id, position } = column;
        const { floor, x, z, base, top } = position;
        const { b, height, h } = geometry;

        const material = floor === selectedFloor - 1 ? selectedMaterial : hideMaterial;

        // Crear geometría y bordes
        const boxGeometry = new BoxGeometry(b, height, h);
        const edgesGeometry = new EdgesGeometry(boxGeometry);

        return (
          <group
            key={`column-${id}-floor-${floor}`}
            position={[x, (base + top) / 2, z]}
          >
            <mesh
              name={`Column_${id}_Floor${floor}`} // ← Renombrado, no comienza con "mesh"
              geometry={boxGeometry}
              material={material}
              onClick={() => (floor === selectedFloor ? console.log(column) : null)}
            />
            {floor === selectedFloor - 1 && (
              <lineSegments
                geometry={edgesGeometry}
                name={`ColumnEdges_${id}_Floor${floor}`} // ← También renombrado
              >
                <lineBasicMaterial color={"black"} linewidth={1} />
              </lineSegments>
            )}
          </group>
        );
      })}
    </>
  );
};

export default Columns;